<div [formGroup]="parent" class="cm-password-input">
  <app-input
    [forceAutofocus]="forceAutofocus || false"
    [type]="showPassword ? 'text' : 'password'"
    label="{{ label || 'shared.common.password' }}"
    placeholder="{{ placeholder }}"
    formControlName="{{ formControlName || 'password' }}"
    errorMessage="{{ errorMessage || 'error.password-validation' }}"
    [isValid]="password?.valid || password?.pristine"
    [size]="size"
  >
    <div
      class="cm-show-password"
      [ngClass]="{ 'cm-show-password-show': !showPassword, 'cm-show-password-hide': showPassword }"
      app-input-addons-right-inside
      (click)="showHidePassword()"
    >
      <span class="sr-only">"{{ 'shared.common.password-show' | translate }}</span>
    </div>
  </app-input>
</div>
